import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-type-jeu',
  templateUrl: './type-jeu.component.html',
  styleUrls: ['./type-jeu.component.css']
})
export class TypeJeuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
